import { CanvasJSON } from '@doer/frontend-components/creativity-editor';
import { MACRO_MEDIA_BASE } from '../../_shared/data/media';
import { buildPillPair } from '../../_shared/pills/pill-pair';
import { buildDiscountValue } from '../../_shared/text/discount-value';
import { buildBenefitLabel } from '../../_shared/pills/benefit-label';
import { buildPaymentMethodText } from '../../_shared/text/payment-method-text';
import { buildLimitText } from '../../_shared/text/limit-text';
import { buildWalletsGroup } from '../../_shared/images/wallets-group';
import { buildLegales } from '../../_shared/text/legales';
import { buildBackgroundImage } from '../../_shared/images/background-image';
import { buildBrandLogos } from '../../_shared/images/brand-logos';

export const macroAhorroDoble1080x1920: CanvasJSON = {
  version: '7.1.0',
  objects: [
    {
      rx: 0,
      ry: 0,
      pieceId: 'background',
      selectable: false,
      evented: false,
      lockMovementX: false,
      lockMovementY: false,
      lockScalingX: false,
      lockScalingY: false,
      lockRotation: false,
      objectCaching: true,
      type: 'Rect',
      version: '7.1.0',
      originX: 'left',
      originY: 'top',
      left: 0,
      top: 0,
      width: 1080,
      height: 1920,
      fill: '#0030eb',
      stroke: null,
      strokeWidth: 0,
      strokeDashArray: null,
      strokeLineCap: 'butt',
      strokeDashOffset: 0,
      strokeLineJoin: 'miter',
      strokeUniform: false,
      strokeMiterLimit: 4,
      scaleX: 1,
      scaleY: 1,
      angle: 0,
      flipX: false,
      flipY: false,
      opacity: 1,
      shadow: null,
      visible: true,
      backgroundColor: '',
      fillRule: 'nonzero',
      paintFirst: 'fill',
      globalCompositeOperation: 'source-over',
      skewX: 0,
      skewY: 0
    },

    buildBackgroundImage({ canvasWidth: 1080, canvasHeight: 1920 }),

    // Shape blanca
    {
      kind: 'svg-url',
      src: `${MACRO_MEDIA_BASE}/templates/macro-ahorro/shape.svg`,
      originX: 'center',
      originY: 'center',
      left: 540,
      top: 996,
      targetWidth: 962,
      targetHeight: 1468
    },

    // Logo Macro
    {
      cropX: 0,
      cropY: 0,
      selectable: true,
      evented: true,
      lockMovementX: false,
      lockMovementY: false,
      lockScalingX: false,
      lockScalingY: false,
      lockRotation: false,
      clipStart: 0,
      objectCaching: true,
      type: 'Image',
      version: '7.1.0',
      originX: 'center',
      originY: 'center',
      left: 540,
      top: 167.8039,
      width: 8930,
      height: 3545,
      fill: 'rgb(0,0,0)',
      stroke: null,
      strokeWidth: 0,
      strokeDashArray: null,
      strokeLineCap: 'butt',
      strokeDashOffset: 0,
      strokeLineJoin: 'miter',
      strokeUniform: false,
      strokeMiterLimit: 4,
      scaleX: 0.0383,
      scaleY: 0.0383,
      angle: 0,
      flipX: false,
      flipY: false,
      opacity: 1,
      shadow: null,
      visible: true,
      backgroundColor: '',
      fillRule: 'nonzero',
      paintFirst: 'fill',
      globalCompositeOperation: 'source-over',
      skewX: 0,
      skewY: 0,
      src: `${MACRO_MEDIA_BASE}/logos/logo-macro-blanco.png`,
      crossOrigin: null,
      filters: []
    },

    // Símbolo de porcentaje A
    {
      fontSize: 62,
      fontWeight: 'bold',
      fontFamily: 'DM Sans',
      fontStyle: 'normal',
      lineHeight: 1.16,
      text: '%',
      charSpacing: 0,
      textAlign: 'center',
      styles: [],
      pathStartOffset: 0,
      pathSide: 'left',
      pathAlign: 'baseline',
      underline: false,
      overline: false,
      linethrough: false,
      textBackgroundColor: '',
      direction: 'ltr',
      textDecorationThickness: 66.667,
      minWidth: 20,
      splitByGrapheme: false,
      selectable: true,
      evented: true,
      lockMovementX: false,
      lockMovementY: false,
      lockScalingX: false,
      lockScalingY: false,
      lockRotation: false,
      clipStart: 0,
      objectCaching: true,
      type: 'Textbox',
      version: '7.1.0',
      originX: 'center',
      originY: 'center',
      left: 552.7021,
      top: 644.0276,
      width: 97.7724,
      height: 70.06,
      fill: '#0030eb',
      stroke: null,
      strokeWidth: 1,
      strokeDashArray: null,
      strokeLineCap: 'butt',
      strokeDashOffset: 0,
      strokeLineJoin: 'miter',
      strokeUniform: false,
      strokeMiterLimit: 4,
      scaleX: 1,
      scaleY: 1,
      angle: 0,
      flipX: false,
      flipY: false,
      opacity: 1,
      shadow: null,
      visible: true,
      backgroundColor: '',
      fillRule: 'nonzero',
      paintFirst: 'fill',
      globalCompositeOperation: 'source-over',
      skewX: 0,
      skewY: 0
    },

    // Símbolo de porcentaje B
    {
      fontSize: 62,
      fontWeight: 'bold',
      fontFamily: 'DM Sans',
      fontStyle: 'normal',
      lineHeight: 1.16,
      text: '%',
      charSpacing: 0,
      textAlign: 'center',
      styles: [],
      pathStartOffset: 0,
      pathSide: 'left',
      pathAlign: 'baseline',
      underline: false,
      overline: false,
      linethrough: false,
      textBackgroundColor: '',
      direction: 'ltr',
      textDecorationThickness: 66.667,
      minWidth: 20,
      splitByGrapheme: false,
      selectable: true,
      evented: true,
      lockMovementX: false,
      lockMovementY: false,
      lockScalingX: false,
      lockScalingY: false,
      lockRotation: false,
      clipStart: 0,
      objectCaching: true,
      type: 'Textbox',
      version: '7.1.0',
      originX: 'center',
      originY: 'center',
      left: 550.7611,
      top: 999.5467,
      width: 97.7724,
      height: 70.06,
      fill: '#0030eb',
      stroke: null,
      strokeWidth: 1,
      strokeDashArray: null,
      strokeLineCap: 'butt',
      strokeDashOffset: 0,
      strokeLineJoin: 'miter',
      strokeUniform: false,
      strokeMiterLimit: 4,
      scaleX: 1,
      scaleY: 1,
      angle: 0,
      flipX: false,
      flipY: false,
      opacity: 1,
      shadow: null,
      visible: true,
      backgroundColor: '',
      fillRule: 'nonzero',
      paintFirst: 'fill',
      globalCompositeOperation: 'source-over',
      skewX: 0,
      skewY: 0
    },

    // Doble pill
    buildPillPair({
      left: { pieceId: 'category', text: 'GASTRONOMÍA', style: 'white-blue-stroke' },
      right: { pieceId: 'valid-days', text: 'Lunes a viernes', style: 'pink-white-text' },
      fontSize: 35,
      paddingX: 21.882,
      paddingY: 7.294,
      strokeWidth: 1.824,
      position: { left: 540, top: 490.3769, width: 632.4051, height: 54.7686 }
    }),

    // Número de descuento A
    buildDiscountValue({
      pieceId: 'discount-value-a',
      text: '20',
      fontSize: 339.4611818194276,
      position: { left: 354.348, top: 758.246, width: 641.7024, height: 383.5911 }
    }),

    // Línea horizontal
    {
      rx: 0,
      ry: 0,
      selectable: true,
      evented: true,
      lockMovementX: false,
      lockMovementY: false,
      lockScalingX: false,
      lockScalingY: false,
      lockRotation: false,
      clipStart: 0,
      objectCaching: true,
      type: 'Rect',
      version: '7.1.0',
      originX: 'center',
      originY: 'center',
      left: 540,
      top: 915,
      width: 180,
      height: 100,
      fill: 'rgb(0,48,235)',
      stroke: '#1e40af',
      strokeWidth: 0,
      strokeDashArray: null,
      strokeLineCap: 'butt',
      strokeDashOffset: 0,
      strokeLineJoin: 'miter',
      strokeUniform: false,
      strokeMiterLimit: 4,
      scaleX: 4.668,
      scaleY: 0.02,
      angle: 0,
      flipX: false,
      flipY: true,
      opacity: 1,
      shadow: null,
      visible: true,
      backgroundColor: '',
      fillRule: 'nonzero',
      paintFirst: 'fill',
      globalCompositeOperation: 'source-over',
      skewX: 0,
      skewY: 0
    },

    // Número de descuento B
    buildDiscountValue({
      pieceId: 'discount-value-b',
      text: '20',
      fontSize: 339.4611818194276,
      fontWeight: 'bold',
      position: { left: 356.2917, top: 1127.5227, width: 641.7024, height: 383.5911 }
    }),

    // Pill con texto del beneficio A
    buildBenefitLabel({
      pieceId: 'benefit-label-a',
      text: 'de ahorro',
      fontSize: 25,
      position: { left: 521.3863, top: 732.8112 },
      paddingX: 27,
      paddingY: 15,
      borderRadius: 30
    }),

    // Pill con texto del beneficio B
    buildBenefitLabel({
      pieceId: 'benefit-label-b',
      text: 'de ahorro',
      fontSize: 25,
      position: { left: 521.3863, top: 1112.3002 },
      paddingX: 27,
      paddingY: 15,
      borderRadius: 30
    }),

    // Texto del método de pago A
    buildPaymentMethodText({
      pieceId: 'payment-method-text-a',
      text: 'Con todas tus tarjetas de Crédito Macro',
      fontSize: 36,
      lineHeight: 0.96,
      textAlign: 'left',
      position: { left: 823.6142, top: 734.0278, width: 390, height: 79.7328 }
    }),

    // Texto del tope A
    buildLimitText({
      pieceId: 'limit-text-a',
      text: 'Tope $10.000 por cuenta, por mes.',
      textAlign: 'left',
      fontSize: 22,
      position: { left: 778.2479, top: 794.5944, width: 303, height: 53.6976 }
    }),

    // Texto del método de pago B
    buildPaymentMethodText({
      pieceId: 'payment-method-text-b',
      text: 'Con todas tus tarjetas de Crédito Macro',
      fontSize: 36,
      lineHeight: 0.96,
      textAlign: 'left',
      position: { left: 819.0761, top: 1111.7593, width: 390, height: 79.7328 }
    }),

    // Texto del tope B
    buildLimitText({
      pieceId: 'limit-text-b',
      text: 'Tope $10.000 por cuenta, por mes.',
      textAlign: 'left',
      fontSize: 22,
      position: { left: 776.3821, top: 1162.0952, width: 303.3061, height: 53.6976 }
    }),

    // Billeteras digitales (slots)
    buildWalletsGroup({ position: { left: 540, top: 1367.4934, height: 70 } }),

    // Logos de marcas
    buildBrandLogos({
      position: { left: 540, top: 1540, width: 600, height: 250 }
    }),

    // Texto con legales
    buildLegales({
      pieceId: 'legales',
      text: 'CARTERA CONSUMO',
      position: { left: 540, top: 1800.7773, width: 683, height: 30.51 }
    })
  ],
  background: 'transparent'
};
